import React, { useState } from 'react';
import { Section } from './ui/Section';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = ['¿Cómo recibo el FUNCIONAL & CROSS 360 después de comprar?', '¿Sirve para profes con poca experiencia o solo para los avanzados?', '¿Es editable? ¿Puedo modificarlo?', '¿Los 6 bonos están en las dos ofertas?', '¿Sirve si doy clases individuales o solo para grupos?', '¿Sirve si tengo alumnos de distintos niveles al mismo tiempo?', '¿Qué diferencia tiene con otros materiales de funcional?', '¿Por qué elegir el FUNCIONAL & CROSS 360 + Elite Coach 360 y no el estándar?', '¿Tiene garantía real?'];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <Section bg="dark-900" data-id="element-117">
      <div className="max-w-3xl mx-auto" data-id="element-118">
        <div className="text-center mb-6 md:mb-12" data-id="element-119">
          <h2 className="text-2xl md:text-4xl font-display font-bold text-white mb-3 md:mb-4" data-id="element-120">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="w-16 md:w-24 h-1 bg-lime-500 mx-auto rounded-full" data-id="element-121"></div>
        </div>

        <div className="space-y-2 md:space-y-4" data-id="element-122">
          {faqs.map((faq, i) => <div key={i} className="bg-dark-800 border border-dark-700 rounded-xl overflow-hidden" data-id="element-123">
              <button onClick={() => toggleFAQ(i)} className="w-full px-4 py-4 md:px-6 md:py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-124">
                <span className="font-medium text-white pr-4 md:pr-8 text-sm md:text-base" data-id="element-125">
                  {faq}
                </span>
                <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-lime-500 flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-126" />
              </button>

              <AnimatePresence data-id="element-127">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-128">
                    <div className="px-4 pb-4 md:px-6 md:pb-5 text-gray-400 border-t border-dark-700 pt-3 md:pt-4 text-sm md:text-base" data-id="element-129">
                      <p data-id="element-130">
                        Esta es una respuesta de ejemplo para la pregunta
                        frecuente. El contenido detallado se proporcionará en el
                        producto final para asegurar que todas las dudas del
                        cliente queden resueltas antes de la compra.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
}